import { render, staticRenderFns } from "./AddonConfigConfirmationDialog.vue?vue&type=template&id=f9f46258&scoped=true&"
import script from "./AddonConfigConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./AddonConfigConfirmationDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddonConfigConfirmationDialog.vue?vue&type=style&index=0&id=f9f46258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f46258",
  null
  
)

export default component.exports